import * as React from 'react';

import { translate } from '~l10n/client';

import { Dialog, DialogProps } from '~shared/components/Dialog';
import { Divider } from '~shared/components/Divider';
import { ImportQuizBySoc } from '~teacher/components/ImportQuizBySoc';
import { ImportQuizBySpreadsheet } from '~teacher/components/ImportQuizBySpreadsheet';
import { useImportQuizBySpreadsheetToWorkspace } from '~teacher/components/workspaces/ImportQuizToWorkspace/hooks';

import { useImportQuizBySocToWorkspace } from './hooks/useImportQuizBySocToWorkspaces';

export interface ImportQuizToWorkspaceDialogProps
  extends Pick<DialogProps, 'open' | 'onClose'> {
  parentId: string;
  workspaceId: string;
}

export function ImportQuizToWorkspaceDialog({
  open,
  onClose,
  workspaceId,
  parentId,
}: ImportQuizToWorkspaceDialogProps) {
  const importQuizBySocToWorkspace = useImportQuizBySocToWorkspace({
    workspaceId: workspaceId,
    parentFolderId: parentId,
    onClose: () => onClose(false),
  });

  const importQuizByExcelToWorkspace = useImportQuizBySpreadsheetToWorkspace({
    workspaceId: workspaceId,
    parentId: parentId,
  });

  return (
    <Dialog
      open={open}
      id="import-quiz-dialog"
      title={translate('Import Quiz')}
      onClose={onClose}
      closeLabel={translate('Close')}
    >
      <div className="my-5">
        <Divider />
      </div>
      <div className="flex flex-col">
        {open ? (
          <ImportQuizBySoc
            importBySocNumber={importQuizBySocToWorkspace.importBySocNumber}
            isDisabled={importQuizBySocToWorkspace.isImportDisabled}
            error={
              importQuizBySocToWorkspace.isError
                ? translate('Please check the SOC number and try again.')
                : null
            }
          />
        ) : null}
        {open && __DEV__ ? (
          <ImportQuizBySpreadsheet
            id="import-quizby-spreadsheet"
            isLoading={importQuizByExcelToWorkspace.isLoading}
            error={importQuizByExcelToWorkspace.error}
            isError={importQuizByExcelToWorkspace.isError}
            progress={importQuizByExcelToWorkspace.progressPercent}
            onUploadFile={importQuizByExcelToWorkspace.handleUploadExcelFile}
          />
        ) : null}
      </div>
    </Dialog>
  );
}
